import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Button from '@/components/Button';
import GenericFilters from '@/components/GenericFilters';
import RangeDatePicker from '@/components/RangeDatePicker/RangeDatePicker';

interface FiltersProps {
  selectedFilters: Record<string, string | string[]>;
  onChange: (filterName: string, value: string) => void;
  clearFilters?: () => void;
  applyFilters?: () => void;
  filters: Array<{ filterName: string; items: Array<{ value: string }> }>;
}

const Filters = ({
  filters,
  selectedFilters,
  onChange,
  clearFilters,
  applyFilters,
}: FiltersProps) => {
  const theme = useTheme();

  const commonPaperStyle = {
    p: 2.5,
    mb: 2,
    borderRadius: 2,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: 'background.paper',
    width: '100%',
  };

  return (
    <Box sx={{ mt: 2, width: '100%', maxWidth: '100%', overflow: 'hidden' }}>
      <Paper elevation={0} sx={commonPaperStyle}>
        <GenericFilters
          filters={filters}
          selectedFilters={selectedFilters}
          handleOnChange={onChange}
          typeCheck="radio"
        />
      </Paper>

      {/* Expiry Date Range Filter */}
      <Box sx={{ mb: 4, mt: 2, width: '100%' }}>
        <Typography
          variant="subtitle1"
          fontWeight="bold"
          sx={{ mb: 2, color: theme.palette.text.primary, fontSize: '1rem' }}
        >
          Rango de Vencimiento
        </Typography>
        <RangeDatePicker
          startLabel="Vence después de"
          endLabel="Vence antes de"
          onChange={onChange}
          startValue={selectedFilters.expiresAfter as string}
          endValue={selectedFilters.expiresBefore as string}
          noPadding
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexWrap: 'wrap',
          '& > button': {
            minWidth: '140px',
            px: 3,
            py: 1,
            [theme.breakpoints.down('sm')]: { width: '100%' },
          },
        }}
      >
        <Button onClick={clearFilters} variant="outlined">
          Limpiar filtros
        </Button>
        <Button onClick={applyFilters} variant="contained">
          Aplicar filtros
        </Button>
      </Box>
    </Box>
  );
};

export default Filters;
